import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  FormControl,
  InputLabel,
  Modal,
  Select,
  MenuItem,
  FormHelperText,
  Stack,
  TextField,
  Typography,
  IconButton,
} from "@mui/material";
import Autocomplete, { createFilterOptions } from "@mui/material/Autocomplete";
import CloseIcon from "@mui/icons-material/Close";
import { Controller, useForm } from "react-hook-form";
import { style, initailState } from "../../Pages/HiringTabDashboard";
import { getProcessName } from "../../Redux/IFlowData/action";
import { useDispatch, useSelector } from "react-redux";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import ReuseableLabel from "../ReusableComponents/ReuseableLabel";
import { accessTokenHeadersObject } from "../../utils/headers";
import {
  getHiringCompanyThroughData,
  getIflowHirngCompany,
  postHiringCompanyInFlow,
  updateIflowHiringCompany,
} from "../../Redux/HiringCompany/action";
import axios from "axios";

export const schema = yup.object().shape({
  name: yup
    .string()
    .required("Hiring company is required")
    .matches(
      /^(?=.*[A-Za-z&])[\w&,().:; -]*[A-Za-z&][\w&,().:; -]*$/,
      "Invalid hiring company & , ( ) . : ; - are allowed with alphabetic characters"
    )
    .test(
      "not only special characters",
      "not only special characters",
      (value) => {
        return /[^\W_]/.test(value);
      }
    )
    .nullable(),
  baseUrl: yup
    .string()
    .required("Base url is required")
    .matches(/^(http|https|www)/, "invalid base url format"),
  website: yup
    .string()
    .required("Website is required")
    .matches(/^(http|https|www)/, "invalid base url format"),
  processName: yup.string().required("Process name is required"),
  verifyToken: yup
    .string()
    .trim()
    .required("Verify token is required")
    .matches(
      /[A-Za-z& 0-9]/,
      "String must contain at least one alphabetic character"
    )
    .matches(/^[^\s]/, "String must not start with a space"),
  bucketName: yup
    .string()
    .required("Bucket name is required")
    .matches(
      /[A-Za-z& 0-9]/,
      "String must contain at least one alphabetic character"
    )
    .matches(/^[^\s]/, "String must not start with a space"),
  /*phone_number_internal: yup
  .string()
  .required("Phone number internal is required")
  .matches(/^\d+$/, "Phone number internal must contain only numbers"),
phone_number_id_internal: yup
  .string()
  .required("Phone number id internal is required")
  .matches(/^\d+$/, "Phone number id internal must contain only numbers"),*/
  sessionTableName: yup
    .string()
    .required("Session table name is required")
    .matches(
      /[A-Za-z& 0-9]/,
      "String must contain at least one alphabetic character"
    )
    .matches(/^[^\s]/, "String must not start with a space"),
  // waToken: yup.string().required("WA token is required"),
});

const EditHiringCompanyModal = ({
  open,
  setOpen,
  handleOnclickEditHiringCompany,
  data,
  setAlert,
  setAlertStatus,
  setalertcontent,
}) => {
  //   console.log(initailState);
  const handleClose = () => setOpen(false);
  //   console.log(data)
  const dispatch = useDispatch();

  const {
    register,
    handleSubmit,
    reset,
    watch,
    control,
    setValue,
    formState: { errors },
  } = useForm({
    defaultValues: initailState,
    resolver: yupResolver(schema),
  });
  const filter = createFilterOptions();
  const [valuex, setValuex] = useState(null);
  const [iflowCompanyData, setIflowCompanyData] = useState("");
  const [iflowCompanyDataId, setIflowCompanyDataId] = useState("");

  // console.log("iflowCompanyData",iflowCompanyData)
  // console.log("valueX", valuex);
  const processNameData = useSelector(
    (state) => state.iflowDataReducer.processName
  );

  const iflowHiringcompanyData = useSelector(
    (state) => state.hiringCompanyReducer.iflowHiringCompany
  );
  const iflowCompanyDetailsById = useSelector(
    (state) => state.hiringCompanyReducer.idFlowHiringCompany
  );
  const hiringCompanyName = watch("name");

  const bucketName = watch("bucketName");
  const hiringCompanyName_bucketname = hiringCompanyName + "-" + bucketName;
  // hiringCompanyName_bucketname.toLowerCase();

  const sessionTableName = watch("sessionTableName");
  const hiringCompanyName_sessionTableName =
    hiringCompanyName + "-" + sessionTableName;
  // hiringCompanyName_sessionTableName.toLowerCase();

  const processName = watch("processName");
  const selectedProcessNameObject = processNameData.filter(
    (el) => el.processname === processName
  );
  // console.log(processNameData)
  // console.log("selectedProcessNameObject", selectedProcessNameObject);
  const processAppURL =
    selectedProcessNameObject[0]?.processDef?.emailConfiguration?.appurl;
  useEffect(() => {
    dispatch(getIflowHirngCompany());
    dispatch(getProcessName());
    dispatch(getHiringCompanyThroughData(data?.iFlowCompanyId));
    reset(data);
  }, [open]);

  // console.log("datatata",data.name)

  useEffect(() => {
    setValue("baseUrl", processAppURL);
  }, [setValue, processAppURL]);

  const handleiFlowData = (valuex) => {
    dispatch(
      updateIflowHiringCompany(data.iFlowCompanyId,{
        resource: {
          ...iflowCompanyDetailsById,
          name:valuex,
          processName: "Initiation Process Pre-Screening",
        },
      })
    )
    .then((res) => {
        if (res.type === "UPDATE_IFLOWHIRINGCOMPANY_SUCCESS") {
          dispatch(getHiringCompanyThroughData(res?.payload.data))
            .then((res) => {
              setIflowCompanyData(res?.idFlowHiringCompany?.code);
              setIflowCompanyDataId(res?.idFlowHiringCompany?.id);
            })
            .catch((err) => {
              console.log(err);
            });
        }else{
        setValuex("")
        setAlert(true);
        setAlertStatus(false);
        setalertcontent(res.error);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  
  const onSubmit = (editData) => {
    processNameData.forEach((val, key) => {
      if (val.processname == editData.processName) {
        editData.processNameIndex = key;
      }
    });
    editData.bucketName = hiringCompanyName_bucketname.toLowerCase();
    editData.sessionTableName =
      hiringCompanyName_sessionTableName.toLowerCase();
    const allProcess = processNameData[Number(editData.processNameIndex)];
    const allProcessRequireObject = {
      processName: allProcess?.processname,
      description: allProcess?.description,
      prefix: allProcess?.prefix,
      processlabel: allProcess?.processlabel,
      processkey: allProcess?.processkey,
    };
    
    const finalObjectData = { ...editData, ...allProcessRequireObject,iFlowCompanyId:iflowCompanyDataId?iflowCompanyDataId:valuex?.id };
    // axios
    //   .get(`https://pilot-dev.reca.ai/compapi/companies/${data.CompanyId}`)
    //   .then((res) => {
    //     console.log("HELLO SIR",res)
    //   }).catch((err)=>{
    //     console.log(err)
    //   });
    handleOnclickEditHiringCompany(finalObjectData);
    // if (data.name !== editData.name) {
    //   dispatch(getHiringCompanyThroughData(data.CompanyId))
    //     .then((res) => {
    //       dispatch(
    //         updateIflowHiringCompany(res.idFlowHiringCompany.id, {
    //           resource: { ...res.idFlowHiringCompany, name: editData.name },
    //         })
    //       )
    //         .then((res) => {
    //           // if (res.payload.status === true) {
    //             // handleOnclickEditHiringCompany(finalObjectData);
    //           // }else{
    //           //   setAlert(true);
    //           //   setAlertStatus(false);
    //           //   setalertcontent("OHHH MAA GO KICHI BHUL ACCHE");
    //           // }              
    //         })
    //         .catch((err) => {
    //           console.log(err);
    //         })
    //         .finally(()=>{
    //           handleOnclickEditHiringCompany(finalObjectData);
    //         });
    //     })
    //     .catch((err) => {
    //       console.log(err);
    //     });
    // } else {
    //   handleOnclickEditHiringCompany(finalObjectData);
    // }
  };

  return (
    <Box>
     <Modal
      open={open}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            <Typography
              variant="h4"
              component="h2"
              sx={{
                textAlign: "center",
                fontWeight: 600,
                color: "primary.darkText",
              }}
            >
              Edit Hiring Company
            </Typography>

            <IconButton
              onClick={handleClose}
              sx={{ position: "absolute", top: 8, right: 8 }}
            >
              <CloseIcon />
            </IconButton>
            
            {/* MODIFICATION: This Stack is now responsive. */}
            <Stack direction={{ xs: 'column', md: 'row' }} spacing={2}>
              <Controller
                name="name"
                control={control}
                render={({ field }) => (
                  <Autocomplete
                    sx={{ width: "100%" }} // Let the Stack control the width
                    defaultValue={data?.name}
                    onChange={(event, newValue) => {
                      if (typeof newValue === "string") setValuex({ name: newValue });
                      else if (newValue && newValue.inputValue) {
                        handleiFlowData(newValue.inputValue);
                        setValuex({ name: newValue.inputValue });
                      } else {
                        setValuex(newValue);
                      }
                    }}
                    filterOptions={(options, params) => {
                      const { inputValue } = params;
                      const uniqueNames = new Set();
                      const filtered = options.filter((option) => {
                        const optionNameLowerCase = option.name.toLowerCase();
                        if (uniqueNames.has(optionNameLowerCase)) return false;
                        uniqueNames.add(optionNameLowerCase);
                        return true;
                      });
                      const matchedOptions = filtered.filter((option) =>
                        option.name.toLowerCase().includes(inputValue.toLowerCase())
                      );
                      if (inputValue !== "" && !uniqueNames.has(inputValue.toLowerCase())) {
                        matchedOptions.push({
                          inputValue,
                          name: `Edit "${inputValue}"`,
                        });
                      }
                      return matchedOptions;
                    }}
                    selectOnFocus
                    clearOnBlur
                    handleHomeEndKeys
                    id="hiring-company-name-autocomplete"
                    options={iflowHiringcompanyData}
                    getOptionLabel={(option) => {
                      if (typeof option === "string") return option;
                      if (option.inputValue) return option.inputValue;
                      return option.name;
                    }}
                    renderOption={(props, option) => <li {...props}>{option.name}</li>}
                    freeSolo
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label={<ReuseableLabel label={"Hiring Company"} />}
                        {...register("name")}
                        error={Boolean(errors.name)}
                        helperText={errors.name?.message}
                      />
                    )}
                  />
                )}
              />
              <TextField
                sx={{ width: "100%" }}
                name="website"
                label={<ReuseableLabel label={"Company Website"} />}
                {...register("website")}
                error={Boolean(errors.website)}
                helperText={errors.website?.message}
              />
            </Stack>

            <FormControl fullWidth error={Boolean(errors.processName)}>
              <InputLabel><ReuseableLabel label={"Process Name"} /></InputLabel>
              <Controller
                name="processName"
                control={control}
                rules={{ required: "Please select an option" }}
                render={({ field }) => (
                  <Select
                    {...field}
                    label={<ReuseableLabel label={"Process Name"} />}
                  >
                    {processNameData.map((el, index) => (
                      <MenuItem value={el.processname} key={index}>
                        {el.processname}
                      </MenuItem>
                    ))}
                  </Select>
                )}
              />
              {errors.processName && <FormHelperText>{errors.processName.message}</FormHelperText>}
            </FormControl>

            <Stack direction={{ xs: 'column', md: 'row' }} spacing={2}>
              <TextField
                fullWidth
                inputProps={{ readOnly: true }}
                name="baseUrl"
                label={<ReuseableLabel label={"Base URL"} />}
                {...register("baseUrl")}
                InputLabelProps={{ shrink: true }}
                error={Boolean(errors.baseUrl)}
                helperText={errors.baseUrl?.message}
              />
              <TextField
                fullWidth
                name="verifyToken"
                label={<ReuseableLabel label={"Verify Token"} />}
                {...register("verifyToken")}
                error={Boolean(errors.verifyToken)}
                helperText={errors.verifyToken?.message}
              />
            </Stack>

            <Stack direction={{ xs: 'column', md: 'row' }} spacing={2}>
              <TextField
                fullWidth
                name="bucketName"
                label={<ReuseableLabel label={"Bucket Name"} />}
                {...register("bucketName")}
                error={Boolean(errors.bucketName)}
                helperText={errors.bucketName?.message}
              />
              <TextField
                fullWidth
                name="sessionTableName"
                label={<ReuseableLabel label={"Session Table Name"} />}
                {...register("sessionTableName")}
                error={Boolean(errors.sessionTableName)}
                helperText={errors.sessionTableName?.message}
              />
            </Stack>

            <TextField
              multiline
              rows={2}
              fullWidth
              name="waToken"
              label="WhatsApp Token"
              {...register("waToken")}
              error={Boolean(errors.waToken)}
              helperText={errors.waToken?.message}
            />

            <Stack direction={{ xs: 'column', md: 'row' }} spacing={2}>
              <TextField fullWidth label="LinkedIn Page" {...register("linkedinPage")} />
              <TextField fullWidth label="Instagram Page" {...register("instagramPage")} />
            </Stack>

            <Stack direction={{ xs: 'column', md: 'row' }} spacing={2}>
              <TextField fullWidth label="Career Page" {...register("careerPage")} />
              <TextField fullWidth label="X Handle" {...register("xHandle")} />
            </Stack>

            <Stack
              direction="row"
              justifyContent="flex-end"
              spacing={2}
              sx={{ width: "100%", pt: 2 }}
            >
              <Button variant="contained" type="submit" >Save</Button>
              <Button variant="outlined" color="secondary" onClick={handleClose}>Cancel</Button>
            </Stack>
          </Box>
        </form>
      </Box>
    </Modal>
    </Box>
  );
};

export default EditHiringCompanyModal;
